import React from "react";
import { Container, Row } from "reactstrap";
import { Link } from 'react-router-dom';
import { getPayloadMedia } from "../../services/payloadService";
import parseHtml from "../../utils/parseHtml";

export default function benefitSec({ data }) {
    const { tituloSeccion, subtituloSeccion, imagen, beneficios, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'work-process';

    if (!beneficios || beneficios.length === 0) return null;

    return (
        <section className="section" id={ancla}>
            <Container>
                <div className="row align-items-center">
                    <div className="col-12 col-lg-6">
                        <div className="me-lg-5">
                            <div className="row justify-content-center">
                                <div className="col-12">
                                    <div className="section-title text-center text-md-start mb-4 pb-2">
                                        <h4 className="title mb-3">{tituloSeccion || 'Beneficios'}</h4>
                                        {subtituloSeccion && (
                                            <p className="para-desc text-body mx-auto mb-0">{parseHtml(subtituloSeccion)}</p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <Row>
                                {beneficios.map((beneficio, index) => (
                                    <div key={index} className="col-md-12 mt-2 pt-2">
                                        <div className="features feature-primary rounded border-0 d-flex">
                                            <div className="feature-icon sm-icon text-center">
                                                <i className={`rounded-pill ${beneficio.icono}`}></i>
                                            </div>

                                            <div className="content flex-1 ms-3">
                                                <Link to="#" className="title h5 text-body">{beneficio.titulo}</Link>
                                                <p className="text-body mt-2 mb-0">{parseHtml(beneficio.descripcion)}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Row>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6 mt-4 pt-2 mt-sm-0 pt-sm-0 mt-lg-0 pt-lg-0">
                        <div className="img-fluid-responsive position-relative">
                            {imagen && (
                                <img
                                    src={getPayloadMedia(imagen.url || imagen[0]?.url)}
                                    className="mx-auto d-block"
                                    alt="Beneficios"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
}
